import React, { useEffect, useState } from 'react';
import './sideBar.css';
import BlueLogo from '../../../POS/assets/images/blueCoco.png';
import pro360Logo from '../../assets/images/pro360.png';

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as Food } from '../../assets/images/svgIcons/Food.svg';
import { ReactComponent as FoodInactive } from '../../assets/images/svgIcons/Food_InActive.svg';
import { ReactComponent as CompleteOrder } from '../../assets/images/svgIcons/CompleteOrder.svg';

import { ReactComponent as ShiftOpening } from '../../assets/images/svgIcons/open.svg';
import { ReactComponent as Handover } from '../../assets/images/svgIcons/cash-pay.svg';
import { ReactComponent as PayIn } from '../../assets/images/svgIcons/in.svg';
import { ReactComponent as TableActive } from '../../assets/images/svgIcons/table-Active.svg';
import { ReactComponent as TableInActive } from '../../assets/images/svgIcons/Table-Inactive.svg';
import { ReactComponent as PayOut } from '../../assets/images/svgIcons/out.svg';
import { ReactComponent as DeliveryB } from '../../assets/images/svgIcons/DeliveryIconB.svg';
import ApiService from '../../services/apiService';
import userManagement from '../../services/userManagement';
import ReceiptModal from '../components/Reports/xReport';
import { FaPizzaSlice, FaChevronRight, FaUser, FaSignOutAlt, FaBars } from 'react-icons/fa';
import { FaTruckDroplet } from 'react-icons/fa6';
import { HiOutlineDocumentReport } from 'react-icons/hi';

const SideBar = ({ id }) => {
  let token = localStorage.getItem('Token');
  let Permission = userManagement?.getUserCrud(token);
  const [activeLink, setActiveLink] = useState(null);
  const [categories, setCategories] = useState([]);
  const [TableEnable, setTableEnable] = useState();
  const [waiterPermission, setWaiterPermission] = useState();
  const [role, setRole] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let token = localStorage.getItem('Token');
    let Permission = userManagement?.getUserCrud(token);
    let role = userManagement?.getUserRole(token);
    setRole(role);
    const isTableEnable = Permission?.includes('Table Managment.add') && Permission.includes('Table Managment.query');
    const waiterPermission = Permission?.includes('Table Managment.add') && Permission.includes('Table Managment.query');
    setWaiterPermission(!waiterPermission);
    setTableEnable(!isTableEnable);
    GetCategory();
  }, []);

  // Update body class when sidebar state changes
  useEffect(() => {
    const body = document.body;
    if (isCollapsed) {
      body.classList.add('sidebar-collapsed');
    } else {
      body.classList.remove('sidebar-collapsed');
    }

    return () => {
      body.classList.remove('sidebar-collapsed');
    };
  }, [isCollapsed]);

  const handleLinkClick = (e) => {
    e.preventDefault();
    setIsModalVisible(true);
  };

  const GetCategory = async () => {
    try {
      const apiService = new ApiService();
      let res = await apiService.get('GET_CATEGORY');
      const filteredcategory = res?.data?.result?.filter((item) => item?.active === true);
      setCategories(filteredcategory);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleMobileToggle = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  // Color scheme
  const primaryColor = '#6E5199';
  const secondaryColor = '#6E5199';
  const inactiveColor = '#3C4469';
  const hoverColor = 'rgba(110, 81, 153, 0.1)';

  // Enhanced navigation items configuration
  const mainNavItems = [
    {
      path: '/cashier/home',
      label: 'Menu',
      icon: Food,
      inactiveIcon: FoodInactive,
      badge: null,
    },
    {
      path: '/Cashier/SaleHistory',
      label: 'Orders',
      icon: CompleteOrder,
      inactiveIcon: CompleteOrder,
      badge: null,
    },
    // {
    //   path: '/Cashier/OpenCashList',
    //   label: 'Cash Opening',
    //   icon: ShiftOpening,
    //   inactiveIcon: ShiftOpening,
    //   badge: null,
    // },
  ];

  const cashierNavItems = [
    // {
    //   path: '/Cashier/HandOvered',
    //   label: 'Cash Closing',
    //   icon: Handover,
    //   inactiveIcon: Handover,
    //   badge: null,
    // },
    {
      path: '/Cashier/PayIn',
      label: 'Pay In',
      icon: PayIn,
      inactiveIcon: PayIn,
      badge: null,
    },
    {
      path: '/Cashier/PayOut',
      label: 'Pay Out',
      icon: PayOut,
      inactiveIcon: PayOut,
      badge: null,
    },
  ];

  const sidebarClasses = `modern-sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`;

  const sidebarStyle = {
    height: '100vh',
    background: 'var(--bg-color, #FFF)',
    boxShadow: '4px 0 20px rgba(110, 81, 153, 0.1)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    borderRight: `1px solid ${primaryColor}20`,
    width: isCollapsed ? '80px' : '280px',
  };

  const logoSectionStyle = {
    padding: isCollapsed ? '20px 10px' : '32px 24px',
    borderBottom: `1px solid ${primaryColor}15`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: isCollapsed ? 'center' : 'flex-start',
    transition: 'all 0.3s ease',
    minHeight: '80px',
  };

  const navSectionStyle = {
    flex: 1,
    padding: '24px 0',
    overflowY: 'auto',
    overflowX: 'hidden',
  };

  const navItemStyle = (isActive) => ({
    display: 'flex',
    alignItems: 'center',
    padding: isCollapsed ? '16px 20px' : '16px 24px',
    margin: isCollapsed ? '4px 8px' : '4px 16px',
    borderRadius: '12px',
    textDecoration: 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    cursor: 'pointer',
    background: isActive ? `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)` : 'transparent',
    color: isActive ? '#FFFFFF' : 'var(--text-color, #3C4469)',
    border: isActive ? 'none' : `1px solid transparent`,
    boxShadow: isActive ? `0 4px 12px ${primaryColor}30` : 'none',
    transform: isActive ? 'translateY(-1px)' : 'translateY(0)',
  });

  const iconContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    marginRight: isCollapsed ? '0' : '16px',
    transition: 'all 0.3s ease',
  };

  const labelStyle = (isActive) => ({
    fontSize: '14px',
    fontWeight: isActive ? '600' : '500',
    letterSpacing: '0.5px',
    opacity: isCollapsed ? 0 : 1,
    transform: isCollapsed ? 'translateX(-10px)' : 'translateX(0)',
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
    color: 'inherit',
  });

  const sectionTitleStyle = {
    fontSize: '12px',
    fontWeight: '700',
    color: 'var(--subheading-color, #6c757d)',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    padding: isCollapsed ? '0' : '0 24px',
    marginBottom: '12px',
    marginTop: '24px',
    opacity: isCollapsed ? 0 : 1,
    transition: 'all 0.3s ease',
  };

  const userSectionStyle = {
    padding: isCollapsed ? '16px 8px' : '20px 24px',
    borderTop: `1px solid ${primaryColor}15`,
    background: 'rgba(110, 81, 153, 0.05)',
  };

  const renderNavItem = (item, isActive) => (
    <NavLink
      key={item.path}
      to={item.path}
      style={navItemStyle(isActive)}
      className="nav-item-enhanced"
      onClick={() => setIsMobileOpen(false)} // Close mobile menu on item click
      onMouseEnter={(e) => {
        if (!isActive) {
          e.target.style.background = hoverColor;
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = `0 2px 8px ${primaryColor}20`;
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.target.style.background = 'transparent';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }
      }}
    >
      <div style={iconContainerStyle}>{isActive ? <item.icon size={24} /> : <item.inactiveIcon size={24} />}</div>
      <span style={labelStyle(isActive)}>{item.label}</span>
      {item.badge && (
        <div
          style={{
            marginLeft: 'auto',
            backgroundColor: '#dc3545',
            color: 'white',
            borderRadius: '12px',
            padding: '2px 8px',
            fontSize: '10px',
            fontWeight: '600',
            opacity: isCollapsed ? 0 : 1,
          }}
        >
          {item.badge}
        </div>
      )}
    </NavLink>
  );

  return (
    <>
      {/* Mobile Overlay */}
      <div className={`sidebar-overlay ${isMobileOpen ? 'active' : ''}`} onClick={() => setIsMobileOpen(false)} />

      {/* Mobile Toggle Button */}
      <button
        className="mobile-toggle"
        onClick={handleMobileToggle}
        style={{
          display: 'none',
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1001,
          background: primaryColor,
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          padding: '12px',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        }}
      >
        <FaBars size={16} />
      </button>

      <nav style={sidebarStyle} className={sidebarClasses}>
        {/* Logo Section */}
        <div style={logoSectionStyle}>
          <img
            src={pro360Logo}
            alt="Logo"
            style={{
              height: isCollapsed ? '32px' : '39px',
              transition: 'all 0.3s ease',
              objectFit: 'contain',
            }}
          />
          {!isCollapsed && (
            <div
              className="logo-text"
              style={{
                marginLeft: '12px',
                opacity: isCollapsed ? 0 : 1,
                transition: 'all 0.3s ease',
              }}
            >
              <div
                style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: primaryColor,
                  lineHeight: '1.2',
                }}
              >
                PRO360
              </div>
              <div
                style={{
                  fontSize: '11px',
                  color: 'var(--subheading-color, #6c757d)',
                  fontWeight: '500',
                }}
              >
                Point of Sale
              </div>
            </div>
          )}
        </div>

        {/* Navigation Section */}
        <div style={navSectionStyle}>
          {/* Main Navigation */}
          <div style={sectionTitleStyle} className="section-title">
            Main Menu
          </div>
          {mainNavItems.map((item) => renderNavItem(item, location.pathname === item.path))}

          {/* Cashier Specific Items */}
          {role === 'Cashier' && (
            <>
              <div style={sectionTitleStyle} className="section-title">
                Cash Management
              </div>
              {cashierNavItems.map((item) => renderNavItem(item, location.pathname === item.path))}
            </>
          )}

          {/* Reports Section */}
          <div style={sectionTitleStyle} className="section-title">
            Reports
          </div>
          <div
            onClick={handleLinkClick}
            style={navItemStyle(false)}
            className="nav-item-enhanced"
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(110, 81, 153, 0.1)';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = `0 2px 8px ${primaryColor}20`;
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            <div style={iconContainerStyle}>
              <HiOutlineDocumentReport size={24} />
            </div>
            <span style={labelStyle(false)} className="nav-label">
              X Report
            </span>
          </div>
        </div>

        {/* User Section */}
        <div style={userSectionStyle}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isCollapsed ? 'center' : 'space-between',
            }}
          >
            {!isCollapsed && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                }}
              >
                <div
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '12px',
                  }}
                >
                  <FaUser size={16} color="white" />
                </div>
                <div>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--text-color, #212529)',
                      lineHeight: '1.2',
                    }}
                  >
                    {(userManagement?.getUserName(token) || 'User').length > 15
                      ? (userManagement?.getUserName(token) || 'User').substring(0, 15) + '...'
                      : userManagement?.getUserName(token) || 'User'}
                  </div>

                  <div
                    style={{
                      fontSize: '12px',
                      color: 'var(--subheading-color, #6c757d)',
                      fontWeight: '500',
                    }}
                  >
                    {role || 'Staff'}
                  </div>
                </div>
              </div>
            )}

            <button
              onClick={handleCollapse}
              style={{
                background: 'transparent',
                border: `1px solid ${primaryColor}30`,
                borderRadius: '8px',
                padding: '8px',
                color: primaryColor,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onMouseEnter={(e) => {
                e.target.style.background = `${primaryColor}10`;
                e.target.style.borderColor = primaryColor;
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.borderColor = `${primaryColor}30`;
              }}
            >
              <FaChevronRight
                size={12}
                style={{
                  transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)',
                  transition: 'transform 0.3s ease',
                }}
              />
            </button>
          </div>
        </div>
      </nav>

      {/* Modal */}
      {isModalVisible && <ReceiptModal isVisible={isModalVisible} onClose={() => setIsModalVisible(false)} />}

      <style jsx>{`
        @media (max-width: 768px) {
          .mobile-toggle {
            display: block !important;
          }
        }
      `}</style>
    </>
  );
};

export default SideBar;
